<template>
    <section>
        <SectionHeading title="Invite link settings" importance="2"/>
        <div class="text-regal-blue-800 mb-4 flex space-x-2.5 items-center w-full bg-regal-blue-100 text-sm rounded-lg p-4">
            <div class="">
                <svg class="w-5 h-5 text-regal-blue-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>
            </div>
            <div class="">
                Anyone can use this link to join Pager. For security, invite links can be set to expire.
            </div>
        </div>
        <form @submit.prevent="updateLink" class="space-y-6">
            <div class="grid grid-cols-4 gap-x-6">
                <div class="">
                    <label for="expiration" class="block font-medium text-gray-800 sm:mt-px sm:pt-2">
                        Expiration
                    </label>
                </div>
                <div class="col-span-3">
                    <select name="expiration" v-model="expirationOptions.selected" @change="onSelected" class="w-full rounded-lg">
                        <option v-for="expirationOption in expirationOptions.options" :key="expirationOption.value" :value="expirationOption.value">{{ expirationOption.label }}</option>
                    </select>
                    <InlineError v-if="form.errors.expiration" :message="form.errors.expiration"/>
                </div>
            </div>
            <div class="w-full flex items-center justify-between">
                <div class="">
                    <div @click="deleteSharedInvite">
                        <Button label="Deactivate link" type="danger outline" />
                    </div>
                </div>
                <div class="">
                    <button type="submit">
                        <Button label="Save" :disabled="form.processing"/>
                    </button>
                </div>
            </div>

        </form>
    </section>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import SectionHeading from '@/Shared/SectionHeading'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'

    export default {
        setup () {
            const form = useForm({
                expiration: null,
            })

            return { form }
        },
        props: {
            sharedInvite: Object,
            expirationOptions: Object,
        },
        emits: [ 'update:open' ],
        components: { SectionHeading, InlineError, Button },
        methods: {
            onSelected(option) {
                this.form.expiration = this.expirationOptions.selected;
            },
            deleteSharedInvite() {
                this.$inertia.delete(route('invites.destroy', this.sharedInvite), {
                    onSuccess: (page) => {
                        this.$emit('update:open', false)
                    },
                })
            },
            updateLink() {
                this.form.patch(route('invites.update', this.sharedInvite), {
                    onSuccess: () => {
                        this.$emit('update:open', false)
                    },
                })
            },
        }
    }
</script>
